<style>
  th:first-child,
  td:first-child{
    padding-left: 1.4em
  }

  #userDetails p{
    color: #555;
  }

  #userDetails span{
    color: #000;
  }
</style>

<template>
  <div>
    <Loader :size="90" v-if="!selectedUser" />
    <div v-else class="row animated fadeIn">
      <div class="col md-4">
        <div id="userDetails" class="card">
          <div class="card-header">Details</div>
          <div class="card-body">
            <p>Name: <span> {{ selectedUser.name }} </span></p>
            <p>Phone: <span> {{ selectedUser.phoneNumber }}</span></p>
            <p>Email: <span> {{ selectedUser.email }} </span></p>
            <p>Id Card: <span> {{ selectedUser.idType }} </span></p>
            <p>Id Number: <span> {{ selectedUser.idNumber }} </span></p>
            <p>Verfied: <span> {{ selectedUser.verifiedAt !== undefined ? 'Yes' : 'No' }} </span></p>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-header"> Accounts </div>
          <Loader :size="90" v-if="selectedUser.accounts === undefined" />
          <table v-else class="table table-stripped" style="border-top: none !important">
            <thead>
              <tr>
                <th>Name</th>
                <th class="text-center">Created On</th>
                <th class="text-center">Balance</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="selectedUser.accounts && selectedUser.accounts.length">
                <tr v-for="(account, index) in selectedUser.accounts" :key="index">
                  <td>{{ account.name }}</td>
                  <td class="text-center"> {{ account.createdAt }} </td>
                  <td class="text-center"> {{ parseInt(account.balance).toLocaleString() }} </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="4" class="text-center">
                  {{ selectedUser.accounts === null ? 'Failed to fetch user accounts' : 'User has no accounts.' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card">
          <div class="card-header"> Transactions</div>
          <Loader :size="90" v-if="selectedUser.transactions === undefined" />
          <table v-else class="table table-stripped" style="border-top: none !important">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>From Account</th>
                <th>To Account</th>
                <th class="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="selectedUser.transactions && selectedUser.transactions.length">
                <tr class="text-capitalize" v-for="(transaction, index) in selectedUser.transactions" :key="index">
                  <td>{{ transaction.date }}</td>
                  <td>{{ transaction.type }}</td>
                  <td>
                    {{ transaction.fromAccount ? transaction.fromAccount.name : transaction.fromExternalAccount || "Unknown" }}
                  </td>
                  <td>{{ transaction.toAccount.name }}</td>
                  <td class="text-center"> {{ parseInt(transaction.amount).toLocaleString() }} </td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="5" class="text-center">
                  {{ selectedUser.transactions === null ? 'Failed to fetch user transactions' : 'User has no transactions.' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Loader from '../../components/Loader'

  export default {
    name: 'dashboard',
    props: {
      userId: {
        type: String,
        required: true
      }
    },
    mounted(){
      if(!this.users){
        if(!this.fetchingUsers)
          this.$store.dispatch('getUsers');

        this.$store.subscribe(mutation => {
          if(mutation.type === 'SET_USERS')
            this.$store.dispatch('setSelectedUser', this.userId);
        });
      }
      else
        this.$store.dispatch('setSelectedUser', this.userId);
    },
    beforeDestroy(){
      this.$store.dispatch('unsetSelectedUser');
    },
    computed: {
      ...mapState(['selectedUser', 'users', 'fetchingUsers'])
    },
    components: {
      Loader
    }
  }
</script>
